<template>
  <div class="p-6 flex-grow-1 container-p-y">
    <div class="card">
      <div class="card-datatable">
        <div class="dataTables_wrapper dt-bootstrap5 no-footer">
          <div class="dataTables_scroll" bis_skin_checked="1">
            <div
              class="dataTables_scrollBody table-container "
              bis_skin_checked="1"
              style="position: relative; overflow: auto; width: 100%;"
            >
              <!-- <div class="col-12 p-6">
                <h4>{{ $t("sidebar.accounts.accounts") }}</h4>
              </div> -->
              <table
                class="dt-scrollableTable table datatables-basic dataTable no-footer table-hover border-top border-bottom dtr-column table-responsive"
                id="accounts_table"
                aria-describedby="DataTables_Table_0_info"
                style="width: 1653px;"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>{{ $t("accounts.first_name") }}</th>
                    <th>{{ $t("accounts.last_name") }}</th>
                    <th>{{ $t("accounts.username") }}</th>
                    <th>
                      {{ $t("accounts.status") }}
                    </th>
                    <th>
                      {{ $t("cards.expires_at") }}
                    </th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="table-border-bottom-0 ">
                  <tr v-for="(item, index) in 3" :key="index">
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                  </tr>
                </tbody>
                <tbody class="table-border-bottom-0 " v-if="!loading">
                  <tr v-for="(account, index) in accounts" :key="index">
                    <td>{{ account.id }}</td>
                    <td>{{ account.first_name }}</td>
                    <td>{{ account.last_name }}</td>
                    <td>
                      <a
                        class="btn btn-link"
                        :href="`accounts/${account.id}`"
                        @click.prevent="$router.push(`/accounts/${account.id}`)"
                        >{{ account.username }}</a
                      >
                    </td>
                    <td>
                      <span
                        v-if="checkExpiration(account.expires_at)"
                        class="badge bg-label-success me-1"
                        >{{ $t("control.not_expired") }}</span
                      >
                      <span v-else class="badge bg-label-danger me-1">{{
                        $t("control.expired")
                      }}</span>
                    </td>
                    <td>{{ formatDate(account.expires_at) }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="col-12 p-6">
                <h4>{{ $t("sidebar.cards.cards") }}</h4>
              </div>

              <table
                class="dt-scrollableTable table datatables-basic dataTable no-footer table-hover border-top border-bottom dtr-column table-responsive"
                id="cards_table"
                aria-describedby="DataTables_Table_0_info"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>{{ $t("cards.username") }}</th>
                    <th>{{ $t("cards.password") }}</th>
                    <th>{{ $t("cards.expires_at") }}</th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="table-border-bottom-0 ">
                  <tr v-for="(item, index) in 3" :key="index">
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                  </tr>
                </tbody>
                <tbody class="table-border-bottom-0 " v-if="!loading">
                  <tr v-for="(card, index) in cards" :key="index">
                    <td>{{ card.id }}</td>
                    <td>
                      <a
                        class="btn btn-link"
                        :href="`cards?username=${card.username}`"
                        @click.prevent="
                          $router.push(`/cards?username=${card.username}`)
                        "
                        >{{ card.username }}</a
                      >
                    </td>
                    <td>{{ card.password }}</td>
                    <td>{{ formatDate(card.expires_at) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  name: "Search",
  data() {
    return {
      accounts: [],
      cards: [],
      loading: false,
      columns: {
        expires_at: {
          sort: 0,
        },
      },
    };
  },
  created() {
    this.fetchSearch();
  },
  watch: {
    $route(newRoute, lastRoute) {
      if (newRoute.query.query != "" && newRoute.query.query != null) {
        this.fetchSearch();
      }
    },
  },
  methods: {
    async fetchSearch() {
      this.loading = true;
      const response = await axios.get(
        `globalsearch?search_query=${this.$route.query.query}`
      );
      if (response.status == 200) {
        this.accounts = response.data.data.accounts;
        this.cards = response.data.data.cards;
      }
      this.loading = false;
    },
    prepareSort() {
      const sort = localStorage.getItem("account_sort");
      if (sort == null) {
        return;
      }
      if (sort == "desc") {
        this.columns.expires_at.sort = -1;
        this.sortByColumn("expires_at");
      } else if (sort == "asc") {
        this.columns.expires_at.sort = 1;
        this.sortByColumn("expires_at");
      }
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    checkExpiration(date) {
      return moment().isBefore(moment(date));
    },
    sortByColumn(column) {
      if (this.columns[column].sort === 0 || this.columns[column].sort === -1) {
        this.columns[column].sort = 1;
        this.accounts.sort((a, b) => {
          if (a[column] > b[column]) return -1;
          if (a[column] < b[column]) return 1;
          return 0;
        });
        localStorage.setItem("account_sort", "desc");
      } else {
        this.columns[column].sort = -1;
        this.accounts.sort((a, b) => {
          if (a[column] < b[column]) return -1;
          if (a[column] > b[column]) return 1;
          return 0;
        });
        localStorage.setItem("account_sort", "asc");
      }
    },
  },
};
</script>
<style scoped>
.sortable {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sortable:hover .arrow-up,
.sortable:hover .arrow-down {
  color: #ccc; /* Slightly darker on hover */
}

.column-title {
  text-transform: uppercase;
  color: #333; /* Dark text color */
}

.sort-arrows {
  display: flex;
  flex-direction: column;
  margin-left: 8px;
}

.arrow-up,
.arrow-down {
  display: block;
  line-height: 1;
  color: transparent; /* Default gray color for inactive arrows */
  transition: color 0.2s ease;
}

.sortable[data-sort="asc"] .arrow-up {
  color: #666; /* Darker color for active ascending arrow */
}

.sortable[data-sort="desc"] .arrow-down {
  color: #666; /* Darker color for active descending arrow */
}
</style>
